import InputMoney from './InputMoney';

// Percentual vazio é permitido (campo opcional); preenchido, não passa de 100.
const isWithinPercentRange = ({ floatValue }) => floatValue === undefined || floatValue <= 100;

/**
 * Input de percentual de 0 a 100, sempre com duas casas ("12,50").
 *
 * Não tem máscara própria: reaproveita o InputMoney, que já cuida do formato pt-BR e entrega
 * no onChange a string numérica limpa ("12.50"). Este componente só fixa as regras de
 * percentual, que antes eram repetidas campo a campo: sempre duas casas, sem sinal de menos
 * e sem passar de 100. Quem usa ainda pode sobrescrever qualquer uma delas via props.
 */
const InputPercent = (props) => (
    <InputMoney
        fixedDecimalScale={true}
        allowNegative={false}
        isAllowed={isWithinPercentRange}
        {...props}
    />
);

export default InputPercent;
